import { useAuthStore } from '@/store';
import { getQueryParams } from '@/utils/fp';
import { useEffect } from 'react';
import { useCurrentPath } from './useCurrentPath/useCurrentPath';

export const useStoreRedirectJwt = () => {
    const { searchParams, isReady } = useCurrentPath();
    const { storedRedirectJwt, setRedirectJwt, isLoggedIn } = useAuthStore((state) => ({
        storedRedirectJwt: state.redirectJwt,
        setRedirectJwt: state.setRedirectJwt,
        isLoggedIn: state.loggedIn,
    }));
    const { redirect_jwt } = getQueryParams(searchParams)('redirect_jwt');

    useEffect(() => {
        if (!isReady) return;
        setRedirectJwt({
            jwt: storedRedirectJwt.jwt ? storedRedirectJwt.jwt : redirect_jwt,
            // set as redirected if no redirect_jwt and user already logged in, to trigger survey-link request
            status: !redirect_jwt && isLoggedIn ? 'redirected' : 'checked',
        });
    }, [isReady, redirect_jwt, storedRedirectJwt.jwt, setRedirectJwt, isLoggedIn]);
};
